<template>
  <div>
    <DataRelease></DataRelease>
  </div>
</template>

<script>

import DataRelease from '../components/DataRelease.vue';

export default {
  components: {
    DataRelease,
  },
};
</script>
